const Services = () => {
  const services = [
    {
      title: "AI Agent Development",
      description: "Custom AI agents tailored to your specific business needs and workflows.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="4" fill="white"/>
            <circle cx="6" cy="6" r="1.5" fill="white"/>
            <circle cx="18" cy="6" r="1.5" fill="white"/>
            <circle cx="18" cy="18" r="1.5" fill="white"/>
            <circle cx="6" cy="18" r="1.5" fill="white"/>
            <line x1="12" y1="12" x2="6" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="18" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="18" y2="18" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="6" y2="18" stroke="white" strokeWidth="1"/>
          </svg>
        </div>
      ),
      features: ["Custom AI Models", "Workflow Integration", "Real-time Learning", "24/7 Monitoring"]
    },
    {
      title: "Process Automation",
      description: "Automate complex business processes with intelligent decision-making capabilities.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="10" width="4" height="4" fill="white" rx="1"/>
            <rect x="10" y="6" width="4" height="4" fill="white" rx="1"/>
            <rect x="18" y="10" width="4" height="4" fill="white" rx="1"/>
            <rect x="10" y="14" width="4" height="4" fill="white" rx="1"/>
            <path d="M6 12L10 8M14 8L18 12M18 12L14 16M14 16L10 16" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Workflow Automation", "Decision Trees", "Exception Handling", "Performance Analytics"]
    },
    {
      title: "Data Intelligence",
      description: "Transform raw data into actionable insights with AI-powered analysis.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="16" width="2" height="6" fill="white" rx="0.5"/>
            <rect x="8" y="12" width="2" height="10" fill="white" rx="0.5"/>
            <rect x="12" y="8" width="2" height="14" fill="white" rx="0.5"/>
            <rect x="16" y="10" width="2" height="12" fill="white" rx="0.5"/>
            <path d="M5 16L9 12L13 8L17 10" stroke="white" strokeWidth="1" strokeLinecap="round"/>
            <circle cx="5" cy="16" r="1" fill="white"/>
            <circle cx="9" cy="12" r="1" fill="white"/>
            <circle cx="13" cy="8" r="1" fill="white"/>
            <circle cx="17" cy="10" r="1" fill="white"/>
          </svg>
        </div>
      ),
      features: ["Predictive Analytics", "Pattern Recognition", "Real-time Processing", "Custom Dashboards"]
    },
    {
      title: "Integration Services",
      description: "Seamlessly integrate AI agents with your existing systems and platforms.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="8" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="16" y="8" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="9" y="2" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="9" y="18" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <line x1="8" y1="10" x2="12" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="16" y1="10" x2="12" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="8" y1="10" x2="12" y2="18" stroke="white" strokeWidth="1"/>
            <line x1="16" y1="10" x2="12" y2="18" stroke="white" strokeWidth="1"/>
            <circle cx="12" cy="12" r="2" fill="white"/>
          </svg>
        </div>
      ),
      features: ["API Integration", "Database Connectivity", "Third-party Tools", "Legacy System Support"]
    },
    {
      title: "Consulting & Strategy",
      description: "Expert guidance on AI implementation and digital transformation strategies.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="3" fill="white"/>
            <path d="M12 2V6M12 18V22M22 12H18M6 12H2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M19.07 4.93L16.24 7.76M7.76 16.24L4.93 19.07M19.07 19.07L16.24 16.24M7.76 7.76L4.93 4.93" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Strategic Planning", "Technology Assessment", "ROI Analysis", "Implementation Roadmap"]
    },
    {
      title: "Training & Support",
      description: "Comprehensive training and ongoing support for your AI systems.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="12" fill="none" stroke="white" strokeWidth="2" rx="2"/>
            <path d="M7 8L10 11L17 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="20" r="2" fill="white"/>
            <path d="M8 20H16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Team Training", "Documentation", "24/7 Support", "Regular Updates"]
    }
  ]

  const process = [
    {
      step: "01",
      title: "Discovery & Analysis",
      description: "We analyze your current systems and identify opportunities for AI enhancement."
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Develop a comprehensive strategy and implementation roadmap tailored to your goals."
    },
    {
      step: "03",
      title: "Development & Testing",
      description: "Build and rigorously test your AI agents to ensure optimal performance."
    },
    {
      step: "04",
      title: "Deployment & Integration",
      description: "Seamlessly deploy and integrate AI agents into your existing infrastructure."
    },
    {
      step: "05",
      title: "Monitoring & Optimization",
      description: "Continuous monitoring and optimization to maximize performance and ROI."
    }
  ]

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-50 to-blue-50 overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-0 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-8">
              Our Services
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
              AI Solutions{' '}
              <span className="block">
                <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  That Deliver Results
                </span>
              </span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-gray-600 leading-relaxed mb-8 max-w-3xl mx-auto">
              From custom AI agent development to comprehensive process automation, 
              we deliver intelligent solutions that transform your business operations.
            </p>
            
            <a 
              href="/contact" 
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <span className="mr-3">Get Started</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14m-7-7l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Comprehensive{' '}
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                AI Services
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Every service is designed to deliver measurable business value and sustainable growth.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {services.map((service, index) => (
              <div 
                key={index}
                className="service-card bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 flex flex-col"
              >
                <div className="mb-6 flex justify-center lg:justify-start">{service.icon}</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <div className="min-h-[4.5rem] mb-6 flex items-start">
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
                
                <ul className="space-y-2 mb-6 flex-grow">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <div className="w-4 h-4 bg-[#212331] rounded mr-3 flex items-center justify-center flex-shrink-0">
                        <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1L3.5 6.5L1 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <a 
                  href="/contact" 
                  className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-300 text-center block"
                >
                  Learn More
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Our{' '}
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Process
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A proven methodology that ensures successful AI implementation and maximum ROI.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {process.map((item, index) => (
              <div key={index} className="flex items-start mb-16 last:mb-0">
                <div className="flex-shrink-0 w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl mr-8">
                  {item.step}
                </div>
                <div className="flex-1 min-h-[120px] flex flex-col justify-start">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{item.title}</h3>
                  <p className="text-gray-600 text-lg leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Let's discuss how our AI services can accelerate your growth and efficiency.
            </p>
            <a 
              href="/contact" 
              className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              Start Your Project
              <svg className="w-5 h-5 ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14m-7-7l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Services
